import { cn } from '@/lib/utils';
import {
  MIETWAGEN_STATUS_COLORS,
  MIETWAGEN_STATUS_LABELS,
  type MietwagenStatus,
} from '@/lib/mietwagenStatus';

export type { MietwagenStatus };

export const MIETWAGEN_STATUS_CONFIG: Record<MietwagenStatus, { label: string; classes: string }> = {
  vertrag_offen:   { label: MIETWAGEN_STATUS_LABELS.vertrag_offen,   classes: MIETWAGEN_STATUS_COLORS.vertrag_offen },
  uebergeben:      { label: MIETWAGEN_STATUS_LABELS.uebergeben,      classes: MIETWAGEN_STATUS_COLORS.uebergeben },
  in_miete:        { label: MIETWAGEN_STATUS_LABELS.in_miete,        classes: MIETWAGEN_STATUS_COLORS.in_miete },
  zurueckgegeben:  { label: MIETWAGEN_STATUS_LABELS.zurueckgegeben,  classes: MIETWAGEN_STATUS_COLORS.zurueckgegeben },
  abgerechnet:     { label: MIETWAGEN_STATUS_LABELS.abgerechnet,     classes: MIETWAGEN_STATUS_COLORS.abgerechnet },
  abgeschlossen:   { label: MIETWAGEN_STATUS_LABELS.abgeschlossen,   classes: MIETWAGEN_STATUS_COLORS.abgeschlossen },
};

interface StatusPillProps {
  status: MietwagenStatus | string | null | undefined;
  className?: string;
}

export function StatusPill({ status, className }: StatusPillProps) {
  if (!status) return null;
  const config = MIETWAGEN_STATUS_CONFIG[status as MietwagenStatus];
  if (!config) return null;

  return (
    <span
      data-testid="mietwagen-status-pill"
      className={cn(
        'inline-flex items-center text-[10px] font-semibold px-2 py-0.5 rounded-full',
        config.classes,
        className,
      )}
    >
      {config.label}
    </span>
  );
}
